import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import {
	AutoCompleteKeyUpObj,
	ConfigDefinitions,
	Meeting_request,
} from "@app/definitions/types"
import * as moment from "moment"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "@app/common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-add-meeting-request",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		CancelBtnComponent,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./add-meeting-request.component.html",
})
export class AddMeetingRequestComponent extends Modalable {
	meetingRequest = new Meeting_request() //the object that holds the field values (and is saved)
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		name: { not_empty: null },
		phone: { not_empty: null },
	}

	insertObj: any = {}
	objNames: any = {}
	isSaving: boolean = false

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.errors = {}
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.meetingRequest,
			this.errors,
			this.validationFields
		)
	}

	async submit() {
		if (!this.isFormSubmittable) {
			return
		} //has errors - exit
		this.isSaving = true
		const res: any = await this.apiService.post(
			"create_meeting_request",
			this.meetingRequest
		)
		this.isSaving = false
		if (res.id) {
			this.onClose.emit(res)
		}
	}
}
